import { PrivacyPolicyTxt } from '../../components/Policy';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen py-10">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <PrivacyPolicyTxt />
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
